import React, { useState, useEffect } from 'react';
import translator from '@Components/Utilities/Translator';
import { gtmPushEvent } from '@Components/Utilities/SandhillsUtility';
import { loadable } from '@Components/Utilities/SandhillsLoadable';
import { modalType } from '@Components/Utilities/SandhillsConstants';
import atoms from '@Components/Utilities/SandhillsAtoms';
import { useRecoilValue } from 'recoil';
import { ThemeProvider } from '@mui/material/styles';
import { useSetRecoilState } from 'recoil';

const CategorySubMenu = loadable(() => import('@Components/Header/CategorySubMenu'));
const UserSettingSelector = loadable(() => import('@Components/Shared/UserSettingSelector'));
const TextSignUpModal = loadable(() => import('@Components/Shared/Modals/TextSignUpModal'));

const HamburgerMenu = (props) => {
    const currentUser = useRecoilValue(atoms.currentUser);
    const theme = useRecoilValue(atoms.muiThemes);
    const currentWebsite = useRecoilValue(atoms.currentWebsite);
    const [isOpen, setOpen] = useState(false);
    const [menuFilter, setMenuFilter] = useState(null);
    const [activeSubMenu, setActiveSubMenu] = useState(null);
    const setShowQsuModal = useSetRecoilState(atoms.showQsu);
    const setShowRaqModal = useSetRecoilState(atoms.showRaq);
    const setShowCookieConsent = useSetRecoilState(atoms.showCookieConsent);
    const [showTsuModal, setShowTsuModal] = useState(false);

    useEffect(() => {
        if (props.showMobileAccount) {
            toggleMenu('AuthLinks');
        }
    }, [props.showMobileAccount]);

    const toggleMenu = (subMenu) => {
        if (subMenu == 'AuthLinks') {
            var authLinks = props.Links.filter(lnk => lnk.Groups.includes('AuthLinks') && lnk.ShowOnMobile);
            if (authLinks && authLinks.length == 1) {
                setActiveSubMenu(authLinks[0]);
            } else {
                setMenuFilter('AuthLinks');
            }
        } else {
            setMenuFilter(null); 
            setActiveSubMenu(null);
        }

        setOpen(!isOpen);
        document.body.style.overflow = isOpen ? '' : 'hidden';
    };

    const getLinks = () => {
        let links = [];

        if (menuFilter && menuFilter == 'AuthLinks') {
            props.Links.filter(lnk => lnk.Groups.includes('AuthLinks') && lnk.ShowOnMobile).map(lnk => links.push(lnk));
        } else {
            props.Links.filter(lnk => lnk.Key == 'lnkHome' && lnk.ShowOnMobile).map(lnk => links.push(lnk));
            props.Links.filter(lnk => lnk.Groups.includes('AuthLinks') && lnk.ShowOnMobile).map(lnk => links.push(lnk));
            props.Links.filter(lnk => lnk.Groups.includes('WatchlistLinks') && lnk.ShowOnMobile).map(lnk => links.push(lnk));
            props.Links.filter(lnk => lnk.Key == 'lnkMyBids').map(lnk => links.push(lnk)); 
            props.Links.filter(lnk => lnk.Key == 'lnkHPCs' && lnk.ShowOnMobile).map(lnk => links.push(lnk));
            props.Links.filter(lnk => lnk.Key == 'lnkMBKCanada' && lnk.ShowOnMobile).map(lnk => links.push(lnk));
            props.Links.filter(lnk => lnk.Key == 'lnkLangSelector' && lnk.ShowOnMobile).map(lnk => links.push(lnk));
            props.Links.filter(lnk => lnk.Key == 'lnkGlobalBrands' && lnk.ShowOnMobile).map(lnk => links.push(lnk));
            props.Links.filter(lnk => lnk.Key == 'lnkCategories' && lnk.ShowOnMobile).map(lnk => links.push(lnk));
            props.Links.filter(lnk => lnk.Groups.includes('BottomRowLinks') && lnk.ShowOnMobile).map(lnk => {
                if (lnk.Key == 'lnkMore') {
                    links = links.concat(lnk.SubMenu.Links);
                } else {
                    links.push(lnk);
                }
            });
            props.Links.filter(lnk => lnk.Key == 'lnkAdvertising' && lnk.ShowOnMobile).map(lnk => links.push(lnk));
            props.Links.filter(lnk => lnk.Key == 'lnkContactUs' && lnk.ShowOnMobile).map(lnk => links.push(lnk));
            props.Links.filter(lnk => lnk.Groups.includes('FooterLinks') && lnk.ShowOnMobile).map(lnk => links.push(lnk));
        }

        return links;
    };

    const toggleSubMenu = (lnk) => {
        if (lnk?.SubMenu) {
            setActiveSubMenu(lnk);
        } else if (lnk?.LinkModalType == modalType.qsuModal) {
            setShowQsuModal(true);
            gtmPushEvent('quick-sign-up-open', 'qsuTriggerType', 'Click');
        } else if (lnk?.LinkModalType == modalType.tsuModal) {
            setShowTsuModal(true);
        } else if (lnk?.LinkModalType == modalType.raqModal) {
            setShowRaqModal(true);
        }

        if (lnk?.GTMEventType) {
            gtmPushEvent(lnk.GTMEventType);
        }

        if (lnk?.ClassName == 'logout-link') {
            localStorage?.removeItem('iterableSubscriptionId');
            localStorage?.removeItem('pushSubscriptionLastUpdate');
        }
    };

    const showCookieConsentModal = () => {
        setShowCookieConsent(true);
        setOpen(!isOpen);
    }

    const getSubMenu = () => {
        let comp = null;
        let lnk = activeSubMenu;

        if (lnk === null) {
            lnk = props.Links.find(lnk => lnk.ClassName === "current-username");
        }

        if (lnk.SubMenu.ReactComponentName === 'UserSettingSelector') {
            comp = <UserSettingSelector key={lnk.Key + '_' + lnk.SubMenu.ReactComponentName} {...lnk.SubMenu.ReactComponentProps.UserSettingSelector} />
        } else if (lnk.SubMenu.ReactComponentName === 'CategorySubMenu') {
            comp = <CategorySubMenu key={lnk.Key + '_' + lnk.SubMenu.ReactComponentName} LogoUrl={props.LogoUrl} LogoImageAltText={props.LogoImageAltText} SiteName={props.CurrentSiteName + props.TLD} AboutUs={props.AboutUs} Categories={props.Categories} useSingleColumn={true} />
        }

        return (
            <>
                <li className='sub-menu-title'>
                    <a>
                        {lnk.Icon &&
                            <>
                                {lnk.IconIsImage ? <img src={lnk.Icon} alt="" /> : <i className={'fas ' + lnk.Icon} />}
                            </>}
                        <span>{lnk.Text}</span>
                    </a>
                </li>
                <li>
                    {comp ?
                        comp :
                        <ul>
                            {lnk.SubMenu.Links.map(sublnk =>
                                <li key={sublnk.Key}>
                                    {renderLink(sublnk)}
                                </li>)}
                        </ul>}
                </li>
            </>
        );
    };

    const renderLink = (lnk) => {
        let classNames = '';
        classNames += lnk.ClassName ? lnk.ClassName : '';
        classNames += lnk.SubMenu ? ' sub-menu-link' : '';
        let isLangSelector = lnk.Key === 'lnkLangSelector';
        classNames += isLangSelector ? ' lang-selector' : '';

        return (
            <>
                {lnk.Url ?
                    <a href={lnk.Url ? lnk.Url : null} target={lnk.TargetName ? lnk.TargetName : null} className={classNames ? classNames : null} onClick={() => toggleSubMenu(lnk)} rel={lnk.Relation ? lnk.Relation : null}>
                        {lnk.Icon &&
                            <>
                                {lnk.IconIsImage ?
                                <img src={lnk.Icon} alt={lnk.IconImageAltText ?? '' } />
                                    :
                                    <i className={'fas ' + lnk.Icon} />
                                }
                            </>
                        }
                        <span>{lnk.Text}</span>
                        {lnk.SubMenu && <i className='sub-menu-arrow fas fa-caret-right' />}
                    </a>
                    :
                    <div role='button' tabIndex='0' onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggleSubMenu(lnk); } }} className={classNames ? classNames : null} onClick={() => toggleSubMenu(lnk)}>
                        {lnk.Icon &&
                            <>
                                {lnk.IconIsImage ?
                                    <>
                                         {(isLangSelector ?
                                                <span>{lnk.Text}
                                                <img src={lnk.Icon} alt={lnk.IconImageAltText ?? ''} />
                                                </span> :
                                            <img src={lnk.Icon} alt={lnk.IconImageAltText ?? ''} />
                                         ) }
                                    </> : <i className={'fas ' + lnk.Icon} />
                                }
                            </>
                        }
                        {(!isLangSelector || (isLangSelector && !lnk.Icon)) && <span>{lnk.Text}</span> }
                        {lnk.SubMenu && <i className='sub-menu-arrow fas fa-caret-right' />}
                    </div>
                }
            </>);
    };

    return (
        <>
        <ThemeProvider theme={theme.darkTheme}>
            <div className='hamburger-menu'>
                <div className={'hm-triggers ' + props.TLD?.replace('.', '')}>
                    <button onClick={toggleMenu} aria-label={translator.translate('sandhills.menu')} aria-expanded={(isOpen ? 'true' : 'false')}>
                        <i className='fas fa-bars' />{translator.translate('sandhills.menu')}
                    </button>
                    {!props.IsHeaderLogoView && !props.skipAccount &&
                        <button onClick={() => toggleMenu('AuthLinks')} aria-label={translator.translate('sandhills.account')}> 
                        <i className='fas fa-user' />{currentUser.IsAuthenticated ? `${translator.translate('sandhills.account')}` :
                            <>
                                
                                {currentWebsite?.Site?.IsBidcaller ? `${translator.translate('sandhills.sso.website.login')}/${translator.translate('sandhills.tradepubwebsite.mvc.register')}` : translator.translate('sandhills.sso.website.login')}
                                
                            </>
                        }
                        </button>
                    }
                </div>
                {isOpen &&
                    <>
                    <div role='button' tabIndex='0' onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggleMenu(); } }} className='hm-overlay' onClick={toggleMenu} aria-label='toggle menu'></div>
                        <nav className='hm-content'>
                            <div className='hm-header'>
                                <div className='sub-menu-back'>
                                    {activeSubMenu &&
                                    <span role='button' tabIndex='0' onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setActiveSubMenu(null); } }} onClick={() => setActiveSubMenu(null)}>
                                            <i className='sub-menu-arrow fas fa-caret-left' />
                                            {translator.translate('sandhills.back')}
                                        </span>}
                                </div>
                            <div role='button' tabIndex='0' onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggleMenu(); } }} className='hm-close' aria-label='toggle menu'><i className='fas fa-2x fa-times' onClick={toggleMenu} /></div>
                            </div>
                            <ul className='hm-list menu-list'>
                            {activeSubMenu || (menuFilter && menuFilter == 'AuthLinks' && currentUser.IsAuthenticated) ? getSubMenu() : getLinks().map(lnk => {
                                if (lnk.Key == 'updatecookies') {
                                    return (<li key={lnk.Key}>
                                        <a role='button' tabIndex='0' onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); showCookieConsentModal(); } }} onClick={showCookieConsentModal} >{lnk.Text}</a>
                                            </li>);
                                } else {
                                    return (<li key={lnk.Key} className={lnk.ApplyStylingToParent ? lnk.ClassName : ''}>{renderLink(lnk)}</li>);
                                }
                            })}
                            </ul>
                        </nav>
                    </>}
            </div>
        </ThemeProvider>
        {showTsuModal && <TextSignUpModal {...props.TextSignUpModel} setShowTsuModal={setShowTsuModal} /> }
        </>
    );
};

export default HamburgerMenu;